interface Duration {
    years: number;
    months: number;
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export function parseISODuration(duration: string): Partial<Duration> {
    const regex = /^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:\.\d+)?)S)?)?$/;
    const match = duration.match(regex);
    if (!match) {
        throw new Error(`Invalid ISO 8601 duration: ${duration}`);
    }

    const [, years, months, days, hours, minutes, seconds] = match;
    return {
        years: parseInt(years || '0', 10),
        months: parseInt(months || '0', 10),
        days: parseInt(days || '0', 10),
        hours: parseInt(hours || '0', 10),
        minutes: parseInt(minutes || '0', 10),
        seconds: parseFloat(seconds || '0')
    };
}

export function addDurationToDate(date: Date, duration: Partial<Duration>): Date {
    const result = new Date(date);
    if (duration.years) {
        result.setFullYear(result.getFullYear() + duration.years);
    }
    if (duration.months) {
        result.setMonth(result.getMonth() + duration.months);
    }
    if (duration.days) {
        result.setDate(result.getDate() + duration.days);
    }
    if (duration.hours) {
        result.setHours(result.getHours() + duration.hours);
    }
    if (duration.minutes) {
        result.setMinutes(result.getMinutes() + duration.minutes);
    }
    if (duration.seconds) {
        result.setSeconds(result.getSeconds() + duration.seconds);
    }
    return result;
}
